import { fork, all } from "redux-saga/effects";

import load from "./load";
import persistence from "./persistence";

export function* persistenceRootSaga() {
  yield all([fork(load), fork(persistence)]);
}
